export const surfaceClassName =
  'rounded-[24px] border border-[var(--theme-border-soft)] bg-[var(--theme-surface-raised)] shadow-[0_14px_34px_rgba(var(--theme-shadow-rgb),0.08)]';
